import { render, staticRenderFns } from "./back.vue?vue&type=template&id=257fa322&"
import script from "./back.vue?vue&type=script&lang=js&"
export * from "./back.vue?vue&type=script&lang=js&"
import style0 from "./back.vue?vue&type=style&index=0&id=257fa322&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports